import { apiFetch } from "../useApi";

export default async function updateDevicesMode({ deviceIds, mode }) {
  const response = await apiFetch(`/devices/update_mode`, {
    method: 'PUT',
    body: JSON.stringify({ deviceIds, mode }),
  });
}
